<template>
    <div>
        <div v-if="pageProp" class="black--text"><label class="v-label theme--light">{{$translate(prop.title)}}</label> {{$translate('controlled by parameter')}} <code>{{pageProp.id}}</code> {{$translate('to the page')}}</div>

        <v-text-field v-if="prop.type == 'text'" :label="translatedTitle" :value="value" @input="inputChanged" color="zoezi-edit-color" :placeholder="translatedPlaceholder" :hint="translatedHint"></v-text-field>

        <v-menu
            v-else-if="prop.type == 'date'"
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="value"
                    :label="translatedTitle"
                    prepend-icon="mdi-calendar"
                    color="zoezi-edit-color"
                    :placeholder="translatedPlaceholder" :hint="translatedHint"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                :value="value"
                @input="dateChanged"
            ></v-date-picker>
        </v-menu>

        <v-textarea v-else-if="prop.type == 'textarea'" :label="translatedTitle" :value="value" @input="inputChanged" color="zoezi-edit-color" :hint="translatedHint"></v-textarea>

        <!--
        <div v-else-if="prop.type == 'translated short'">
            <v-text-field :label="translatedTitle" :value="value[propstate[prop.name] ||'sv']" @input="inputChanged" :key="propstate[prop.name]" color="zoezi-edit-color">
                <template v-slot:append>
                    <img v-if="propstate[prop.name] != 'en'" :src="getFlag('sv')" @click="$set(propstate, prop.name, 'en')" style="cursor: pointer" />
                    <img v-else :src="getFlag('en')" @click="$set(propstate, prop.name, 'sv')" style="cursor: pointer" />
                </template>
            </v-text-field>
        </div>

        <div v-else-if="prop.type == 'translated long'">
            <v-textarea :label="translatedTitle" :value="[propstate[prop.name] ||'sv']" @input="inputChanged" :key="propstate[prop.name]" color="zoezi-edit-color">
                <template v-slot:append>
                    <img v-if="propstate[prop.name] != 'en'" :src="getFlag('sv')" @click="$set(propstate, prop.name, 'en')" style="cursor: pointer" />
                    <img v-else :src="getFlag('en')" @click="$set(propstate, prop.name, 'sv')" style="cursor: pointer" />
                </template>
            </v-textarea>
        </div> -->

        <v-switch v-else-if="prop.type == 'checkbox'" :label="translatedTitle" :input-value="value" @change="inputChanged" color="zoezi-edit-color" :hint="translatedHint" :persistent-hint="!!hint"></v-switch>

        <div v-else-if="prop.type == 'icon'">
            <icon-setting :label="translatedTitle" :value="value" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'image'">
            <image-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint"/>
        </div>

        <div v-else-if="prop.type == 'video'">
            <video-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint"/>
        </div>

        <div v-else-if="prop.type == 'vue'">
            <vue-code-setting :value="value" :label="translatedTitle" :component="component" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'html'">
            <editor v-if="prop.typeinfo && prop.typeinfo.inline"  :value="value" @input="inputChanged" />
            <vue-code-setting v-else :value="value" :label="translatedTitle" @input="inputChanged" html-only :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'javascript'">
            <label class="v-label theme--light">{{translatedTitle}}</label>
            <codemirror
                :value="value"
                :options="cmOptionJs"
                @input="inputChanged"
                style="border: 1px solid gray"
            />
        </div>

        <v-text-field v-else-if="prop.type == 'number'"
                      :value="value"
                      :label="translatedTitle"
                      type="number"
                      :min="(prop.typeinfo && prop.typeinfo.min) || 0"
                      :max="(prop.typeinfo && prop.typeinfo.max) || undefined"
                      :placeholder="translatedPlaceholder"
                      color="zoezi-edit-color"
                      @input="inputChanged(Number($event))"
        ></v-text-field>

        <v-slider v-else-if="prop.type == 'number-slider'"
                  :value="value"
                  :label="translatedTitle"
                  :min="prop.typeinfo.min"
                  :max="prop.typeinfo.max"
                  :step="prop.typeinfo.step"
                  thumb-label
                  @end="inputChanged(Number($event))"
        ></v-slider>

        <div v-else-if="prop.type == 'range'">
            <label class="v-label theme--light">{{prop.title}}</label>
            <v-range-slider
                :value="value"
                :max="prop.typeinfo.max"
                :min="prop.typeinfo.min"
                hide-details
                class="align-center"
                @input="inputChanged"
                color="zoezi-edit-color"
            >
                <template v-slot:prepend>
                    <v-text-field
                        :value="value[0]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @input="$set(value, 0, $event)"
                        color="zoezi-edit-color"
                    ></v-text-field>
                </template>
                <template v-slot:append>
                    <v-text-field
                        :value="value[1]"
                        class="mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 60px"
                        @input="$set(value, 1, $event)"
                        color="zoezi-edit-color"
                    ></v-text-field>
                </template>
            </v-range-slider>
        </div>

        <div v-else-if="prop.type == 'namelist'">
            <name-list-setting :value="value" :component="component" :prop="prop" :label="translatedTitle" @input="inputChanged" />
        </div>

        <div v-else-if="prop.type == 'componentlist'">
            <component-list-setting :value="value" :component="component" :label="translatedTitle" :prop="prop" @input="inputChanged" />
        </div>

        <div v-else-if="prop.type == 'component'">
            <template v-if="$root.edit">
                <label class="v-label theme--light">{{translatedTitle}}</label>
                <div @click="setSelectedEditComponentFromConfig(value)" style="cursor: pointer" class="black--text">
                    <div v-if="value && value.component" style="line-height: 40px" class="d-flex">
                        <div class="flex-grow-1">
                            <v-icon>{{componentInfo(value.component).zoezi.icon}}</v-icon>
                            {{$translate(componentInfo(value.component).zoezi.title)}}
                        </div>
                        <v-btn icon v-if="prop.typeinfo && prop.typeinfo.clearable" @click.prevent="inputChanged(makeEmptyConfig())"><v-icon >mdi-close</v-icon></v-btn>
                    </div>
                    <div v-else>{{$translate('No component')}}</div>
                </div>
            </template>
            <template v-else>
                <select-setting :value="value" :label="translatedTitle" :prop="{title: translatedTitle, typeinfo: {text: 'text', value: 'value', clearable: prop.typeinfo.clearable, getItems: getComponents}}" :props="config.props" @input="inputChanged" :hint="translatedHint" />
            </template>
        </div>

        <div v-else-if="prop.type == 'color'">
            <color-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" :showDefaultColors="prop.typeinfo && prop.typeinfo.showDefaultColors != undefined ? prop.typeinfo.showDefaultColors : true"/>
        </div>

        <div v-else-if="prop.type == 'page'">
            <page-setting :label="translatedTitle" :value="value" @input="inputChanged" :clearable="prop.typeinfo ? prop.typeinfo.clearable : true" :route-filter="prop.typeinfo ? prop.typeinfo.routeFilter : null" :props="config.props" />
        </div>

        <div v-else-if="prop.type == 'link'">
            <link-setting :label="translatedTitle" :value="value" :clearable="prop.typeinfo ? prop.typeinfo.clearable : true"  @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'path'">
            <v-text-field :label="translatedTitle" :value="value" @input="pathChanged" :rules=[isValidPath] color="zoezi-edit-color" :hint="translatedHint"></v-text-field>
        </div>

        <div v-else-if="prop.type == 'select'">
            <select-setting :value="value" :label="translatedTitle" :prop="prop" :props="config.props" @input="inputChanged" :hint="translatedHint"/>
        </div>

        <div v-else-if="prop.type == 'alignment'">
            <alignment-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'productlist'">
            <product-list-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'csssize'">
            <css-size-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'backgroundposition'">
            <background-position-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'breakpointsetting'">
            <breakpoint-setting :value="value" :label="translatedTitle" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'checktoggle'">
            <check-toggle-setting :value="value" :label="translatedTitle" :headers="prop.typeinfo ? prop.typeinfo.header : []" @input="inputChanged" />
        </div>

        <div v-else-if="prop.type == 'pageparams'">
            <page-params-setting :value="value" :label="translatedTitle" :page="config" @input="inputChanged" />
        </div>

        <div v-else-if="prop.type == 'font'">
            <font-setting :label="translatedTitle" :value="value" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'colortheme'">
            <color-theme-settings :label="translatedTitle" :value="value" @input="inputChanged" :hint="translatedHint" />
        </div>

        <div v-else-if="prop.type == 'itemlist'">
            <item-list-setting :label="prop.translatedTitle" :value="value" @input="inputChanged"/>
        </div>

        <div v-else-if="prop.type == 'multitext'">
            <multi-text-setting :label="translatedTitle" :value="value" :config="prop.typeinfo.config" @input="inputChanged"/>
        </div>

        <div v-else>
            <v-alert color="error">{{$translate('The setting {0} lacks a supported setting type').format(translatedTitle)}} ({{prop.type}})</v-alert>
        </div>
    </div>
</template>

<script>
import ColorSetting from './ColorSetting.vue'
import ImageSetting from './ImageSetting.vue'
import AlignmentSetting from './AlignmentSetting.vue'
import VideoSetting from './VideoSetting.vue'
import ComponentListSetting from './ComponentListSetting.vue'
import NameListSetting from './NameListSetting.vue'
import SelectSetting from './SelectSetting.vue'
import IconSetting from './IconSetting.vue'
import LinkSetting from './LinkSetting.vue'
import PageSetting from './PageSetting.vue'
import ProductListSetting from './ProductListSetting.vue'
import CssSizeSetting from './CssSizeSetting.vue'
import BreakpointSetting from './BreakpointSetting.vue'
import BackgroundPositionSetting from './BackgroundPositionSetting.vue'
import VueCodeSetting from './VueCodeSetting.vue'
import CheckToggleSetting from './CheckToggleSetting.vue'
import PageParamsSetting from './PageParamsSetting.vue'
import FontSetting from './FontSetting.vue'
import ColorThemeSettings from './ColorThemeSettings.vue'
import Editor from './Editor.vue'
import ItemListSetting from './ItemListSetting.vue'
import MultiTextSetting from './MultitextSetting.vue'
import components from '../component.js'
import {isValidPath} from '../util.js'

export default {
    name: 'ComponentSetting',

    props: ['value', 'prop', 'config'],

    components: {
        ColorSetting,
        ImageSetting,
        AlignmentSetting,
        VideoSetting,
        ComponentListSetting,
        NameListSetting,
        SelectSetting,
        IconSetting,
        LinkSetting,
        PageSetting,
        ProductListSetting,
        CssSizeSetting,
        BreakpointSetting,
        BackgroundPositionSetting,
        VueCodeSetting,
        CheckToggleSetting,
        PageParamsSetting,
        FontSetting,
        ColorThemeSettings,
        Editor,
        ItemListSetting,
        MultiTextSetting
    },

    computed: {
        component() {
            return this.$store.state.editComponent;
        },
        pageProp() {
            return this.config?.style?.pageParams?.find(p => p.prop == this.prop.name);
        },
        hint() {
            return this.prop.typeinfo?.hint;
        },
        translatedTitle() {
            return this.$translate(this.prop.title);
        },
        translatedPlaceholder() {
            if (this.prop.typeinfo?.placeholder) {
                return this.$translate(this.prop.typeinfo.placeholder);
            }
            return null;
        },
        translatedHint() {
            if (this.prop.typeinfo?.hint) {
                return this.$translate(this.prop.typeinfo.hint);
            }
            return null;
        },
    },

    data: () => ({
        cmOptionJs: {
            tabSize: 2,
            indentUnit: 2,
            matchBrackets: true,
            mode: 'text/javascript',
            readOnly: false
        },
        dateMenu: null
    }),

    methods: {
        inputChanged(value) {
            this.$emit('input', value);
        },
        dateChanged(value) {
            this.dateMenu = false;
            this.$emit('input', value);
        },
        getFlag(lang) {
            const hostname = this.$root.siteconfig?.hostname || location.hostname;
            return `${location.protocol}//${hostname}/assets/img/flags/${lang}.png`;
        },
        componentInfo(name) {
            return components.getComponent(name);
        },
        setSelectedEditComponentFromConfig(config) {
            this.$store.dispatch('setEditComponentConfig', {config, parentComponent: this.$store.state.editComponent})
        },
        makeEmptyConfig() {
            return components.makeEmptyConfig();
        },
        isValidPath(x) {
            if (!isValidPath(x)) {
                return 'Felaktiga tecken i sökvägen';
            }

            return true;
        },
        pathChanged(x) {
            if (isValidPath(x)) {
                this.inputChanged(x);
            }
        },
        getComponents() {
            return components.getComponents().map(c => ({text: c.zoezi.title, value: c.name}));
        }
    }
}
</script>
